var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSurveysEnabled)?_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[(_vm.isSurveyDlgRendered)?_c('survey-dlg',{attrs:{"survey":_vm.userSurvey}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }